import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingVertical, HorizontalPadding, responsiveImageSize } from '../common/responsive.utils';
import QuestionOnIcon from '../../assets/icon/sitter/mobile/question_on.svg';
import QuestionOffIcon from '../../assets/icon/sitter/mobile/question_off.svg';

const MainWebQnaComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    const [visible01Web, setVisible01Web] = React.useState(false);
    const [visible02Web, setVisible02Web] = React.useState(false);
    const [visible03Web, setVisible03Web] = React.useState(false);
    const [visible04Web, setVisible04Web] = React.useState(false);

    const [visible01Mobile, setVisible01Mobile] = React.useState(false);
    const [visible02Mobile, setVisible02Mobile] = React.useState(false);
    const [visible03Mobile, setVisible03Mobile] = React.useState(false);
    const [visible04Mobile, setVisible04Mobile] = React.useState(false); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.com7ColorConn_Web}>
                        <span style={styles.title_Web}>
                            자주 묻는 질문
                        </span>

                        <div style={{ height: 30 }} />

                        <div style={visible01Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible01Web(!visible01Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible01Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible01Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        돌봄품앗이가 뭔가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible01Web) ?
                                <span style={styles.contentTxt_Web}>
                                    반려동물 돌봄이 필요할 때, 우리동네 견주/집사님과 돌봄을 주고 받는 것을 의미해요. 우주펫에서 친하게 지낼 이웃 반려인을 찾아보세요.
                                </span>
                                : null
                        }

                        <div style={visible02Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible02Web(!visible02Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible02Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible02Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        우주펫은 무료서비스인가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible02Web) ?
                                <span style={styles.contentTxt_Web}>
                                    우주펫의 품앗이 이웃 찾기는 무료 서비스에요. 부담없이 우리동네 반려인들과 소통을 시작해보세요.
                                </span>
                                : null
                        }


                        <div style={visible03Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible03Web(!visible03Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible03Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible03Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        현재 오픈된 지역은 어디인가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible03Web) ?
                                <span style={styles.contentTxt_Web}>
                                    우주펫은 전국 어디서든 이용할 수 있어요.
                                </span>
                                : null
                        }

                        <div style={visible04Web ? styles.selectedCon_Web : styles.unSelectedCon_Web} onClick={() => { setVisible04Web(!visible04Web) }}>
                            <div style={styles.rowCon_Web}>
                                {
                                    (visible04Web) ? <img src={QuestionOnIcon} style={styles.questionIcon_Web} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Web} alt="?" />
                                }
                                <div style={styles.colCon_Web}>
                                    <span style={(visible04Web) ? styles.titleTxt_Web : styles.unSelectInfoTxt_Web}>
                                        반려동물을 키운 경험이 있거나, 본가에 반려동물이 있는데 서비스 이용이 가능한가요?
                                    </span>
                                </div>
                            </div>
                        </div>

                        {
                            (visible04Web) ?
                                <div style={styles.colCon_Web}>
                                    <span style={styles.contentTxt_Web}>
                                        네, 현재 반려동물을 키우고 있지 않더라도 반려동물을 키운 경험만 있다면 우주펫 가입이 가능해요.
                                    </span>
                                </div>
                                : null
                        }
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <span style={styles.title_Mobile}>
                            자주 묻는 질문
                        </span>

                        <div style={{ height: "2vh" }} />

                        <div style={visible01Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible01Mobile(!visible01Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible01Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible01Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        돌봄품앗이가 뭔가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible01Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                반려동물 돌봄이 필요할 때, 우리동네 견주/집사님과 돌봄을 주고 받는 것을 의미해요. 우주펫에서 친하게 지낼 이웃 반려인을 찾아보세요.
                                            </span>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible02Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible02Mobile(!visible02Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible02Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible02Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        우주펫은 무료서비스인가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible02Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                우주펫의 품앗이 이웃 찾기는 무료 서비스에요. 부담없이 우리동네 반려인들과 소통을 시작해보세요.
                                            </span>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible03Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible03Mobile(!visible03Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible03Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible03Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        현재 오픈된 지역은 어디인가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                    (visible03Mobile) ?
                                            <span style={styles.contentTxt_Mobile3}>
                                            우주펫은 전국 어디서든 이용할 수 있어요.
                                        </span>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div style={visible04Mobile ? styles.selectedCon_Mobile : styles.unSelectedCon_Mobile} onClick={() => { setVisible04Mobile(!visible04Mobile) }}>
                            <div style={styles.colCon_Mobile}>
                                <div style={styles.rowCon_Mobile}>
                                    {
                                        (visible04Mobile) ? <img src={QuestionOnIcon} style={styles.questionIcon_Mobile} alt="?" /> : <img src={QuestionOffIcon} style={styles.questionIcon_Mobile} alt="?" />
                                    }
                                    <span style={(visible04Mobile) ? styles.titleTxt_Mobile : styles.unSelectInfoTxt_Mobile}>
                                        반려동물을 키운 경험이 있거나, 본가에 반려동물이 있는데 서비스 이용이 가능한가요?
                                    </span>
                                </div>
                                <div style={styles.colCon_Mobile}>
                                    {
                                        (visible04Mobile) ?
                                            <span style={styles.contentTxt_Mobile}>
                                                    네, 현재 반려동물을 키우고 있지 않더라도 반려동물을 키운 경험만 있다면 우주펫 가입이 가능해요.
                                            </span>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    title_Web: { fontSize: responsiveFont(20, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "120%",  paddingLeft: HorizontalPadding(24, 88) },
    titleTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 28), fontWeight: 600, letterSpacing: "-1%", color: "black", lineHeight: "140%" },
    unSelectInfoTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 28), fontWeight: 400, letterSpacing: "-1%", color: "#454A50", lineHeight: "140%" },
    contentTxt_Web: { marginLeft: HorizontalPadding(24, 88), fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", marginBottom: "26px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "90%" },
    unSelectedCon_Web: { marginLeft: HorizontalPadding(24, 88), width: "90%",    paddingRight: "18px", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", borderBottom: "0.1px solid rgb(232, 232, 233)" },
    selectedCon_Web: { width: "90%", backgroundColor: "#FFFFFF", paddingLeft: HorizontalPadding(24, 88), paddingRight: "22px", paddingTop: "18px", paddingBottom: "18px", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    rowCon_Web: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start" },
    colCon_Web: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", marginLeft: 6 ,},
    questionIcon_Web: { width: responsiveImageSize(22, 39), height: responsiveImageSize(22, 39) },
    com7ColorConn_Web: { backgroundColor: "#fff", boxSizing: "border-box", display: "flex", flexDirection: "column", paddingBottom: responsivePaddingVertical(50, 90), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: HorizontalPadding(10, 30), paddingRight: HorizontalPadding(10, 30)},

    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "white", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingTop: "4.6875vh"},
    title_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(20, 40), fontWeight: 700, letterSpacing: "-1%", alignSelf: "flex-start", paddingLeft: "7.5vw", lineHeight: "120%" },
    titleTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 28), fontWeight: 600, letterSpacing: "-1%", color: "black", lineHeight: "140%" },
    unSelectInfoTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(16, 28), fontWeight: 400, letterSpacing: "-1%", color: "#454A50", lineHeight: "140%" },
    contentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", marginTop: "2.5vw", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "90%" },
    contentTxt_Mobile3: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 24), fontWeight: 400, letterSpacing: "-2%", color: "#62686D", marginTop: "2.5vw", lineHeight: "150%", paddingLeft: "18px", paddingRight: "18px", paddingTop: "22px", paddingBottom: "22px", borderRadius: "16px", backgroundColor: "#FAFAFB", width: "77.5vw" },
    unSelectedCon_Mobile: { width: "100%", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), paddingLeft: HorizontalPadding(24, 88), paddingRight: "6.5vw", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    selectedCon_Mobile: { width: "100%", display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", paddingTop: HorizontalPadding(14, 26), paddingBottom: HorizontalPadding(14, 26), paddingLeft: HorizontalPadding(24, 88), paddingRight: "6.5vw", },
    rowCon_Mobile: { display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start" },
    colCon_Mobile: { display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" },
    questionIcon_Mobile: { width: responsiveImageSize(22, 39), height: responsiveImageSize(22, 39), boxSizing: "border-box", marginRight: "1.8750vw" },
});

export default MainWebQnaComponent;